<!-- ── Input area: chips + search input (mirrors desktop layout) ─────────── -->
<div
  class="multiple-suggester location-suggester mb-2"
  [class.multiple-suggester-with-items]="context.chipItems().length"
>
  <div class="input-group-right-icon form-control position-relative">
    <!-- Chips — collapsable, with location-aware popover (name + include/exclude label). -->
    <f-location-chip-group
      [items]="$any(context.chipItems())"
      [invalidItems]="$any(context.excludedChipItems())"
      (remove)="context.onChipRemove($any($event))"
      (removeAll)="context.onRemoveAll()"
      (itemClick)="context.onChipItemClick($event)"
    ></f-location-chip-group>

    <!-- Search input -->
    <div class="input-wrapper">
      <input
        #inputEl
        type="text"
        [placeholder]="context.resolvedLabels.placeholder"
        [value]="context.searchText()"
        (input)="context.onTextInput($event)"
        (keydown)="context.onKeyDown($event)"
        autocomplete="off"
        data-automation-id="location-suggester-mobile-input"
      />
      @if (context.searchText().length) {
      <i class="f-i f-i-close" (click)="context.clearSearch($event)"></i>
      }
    </div>
  </div>
</div>

<!-- ── Results list ───────────────────────────────────────────────────────── -->
<f-list class="location-suggester-list" [withConcisedItems]="false">
  <!-- ── Typeahead suggestions (while typing) ───────────────────────────── -->
  @if (context.showSuggest()) { @for (item of context.suggestedItems(); track item.key; let i = $index) {
  <f-list-item
    class="suggest-item location-item d-flex align-items-center justify-content-between gap-2 px-3 py-2"
    [ngClass]="'location-item-type-' + item.data.type"
    [active]="context.isItemActive(item)"
    [withHover]="true"
    [class.location-item-highlighted]="i === context.highlightedSuggestIndex()"
    (click)="context.toggleSelectionType(item); $event.stopPropagation()"
  >
    <span class="suggest-item-text flex-grow-1 overflow-hidden text-truncate">
      <span class="suggest-item-text-before">{{ item.data.name.substring(0, item.searchContext.startIdx) }}</span>
      <span class="suggest-item-text-match fw-bold">{{
        item.data.name.substring(item.searchContext.startIdx, item.searchContext.endIdx)
      }}</span>
      <span class="suggest-item-text-after text-muted">{{ context.getSuggestSuffix(item) }}</span>
    </span>

    <div class="d-flex gap-2 flex-shrink-0">
      <a
        class="link-danger location-item-button-exclude"
        [class.fw-bold]="context.isItemExcluded(item)"
        (click)="context.selectItem(item, SelectionType.Exclude, $event)"
        >{{
          context.isItemExcluded(item) ? context.resolvedLabels.excludedText : context.resolvedLabels.excludeText
        }}</a
      >
      <a
        class="link-primary location-item-button-include"
        [class.fw-bold]="context.isItemIncluded(item)"
        (click)="context.selectItem(item, SelectionType.Include, $event)"
        >{{
          context.isItemIncluded(item) ? context.resolvedLabels.includedText : context.resolvedLabels.includeText
        }}</a
      >
    </div>
  </f-list-item>
  } @if (context.suggestedItems().length === 0) {
  <f-list-item [withHover]="false" class="px-3 py-2">
    <span class="text-muted body-50">{{ context.resolvedLabels.noResults }}</span>
  </f-list-item>
  } }

  <!-- ── Hierarchy tree (at rest, no text typed) ────────────────────────── -->
  @if (!context.showSuggest()) {
  <f-location-hierarchy-item
    [items]="context.hierarchyItems()"
    [selectedItems]="context.selectedItems()"
    [excludeText]="context.resolvedLabels.excludeText"
    [excludedText]="context.resolvedLabels.excludedText"
    [includeText]="context.resolvedLabels.includeText"
    [includedText]="context.resolvedLabels.includedText"
    (itemSelect)="context.onHierarchySelect($event)"
    (itemToggle)="context.onHierarchyToggle($event)"
  ></f-location-hierarchy-item>
  }
</f-list>
